import { render, staticRenderFns } from "./CadastroForm.vue?vue&type=template&id=9d8dd7b0&"
import script from "./CadastroForm.vue?vue&type=script&lang=js&"
export * from "./CadastroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports